export default "__VITE_ASSET__C_Ft6GTp__"